export default __webpack_public_path__ + "static/bg_cta_sp-2033d427169616733751a7b123a19236.png";